global.axios = require('axios');
global.$ = global.jQuery = require('jquery');
global.youtube_background = require('youtube-background');
global.dropzone = require('dropzone');

$(function() {
    //console.log('ready');
});

import 'slick-carousel';
import 'lity';

//import '../../../../../../public/assets/public/js/ecommerce-public';

import './checkout';
import './basket';
import './product-prices';
import './shared';
import './supplier-portal';
import './bdm-lookup';
import './order';

// window.YT.ready(function () {
//     $(document).ready(function () {
//         $('[data-vbg]').youtube_background();
//     });
// });

const videoBackgrounds = new VideoBackgrounds('[data-vbg]');

$(document).on('keyup', '#searchparam-header-autocomplete', function() {
    let val = $(this).val();

    if(val.length > 0) {
        $('#searchparam-header-autocomplete-placeholder').hide();
    } else {
        $('#searchparam-header-autocomplete-placeholder').show();
    }

    quickSearch(val);
});

$(document).on('focusin', '#searchparam-header-autocomplete', function() {
    let val = $(this).val();

    if(val.length > 0) {
        quickSearch(val);
    }
});

$(document).on('click', function (event) {
    if ($(event.target).closest('.tt-suggestion').length === 0) {
        $('.searchbox__results').removeClass('active');
    }

    event.stopPropagation();
});

function quickSearch(val) {
    axios.get('/quicksearch?for=' + val)
    .then(function (response) {
        $('.tt-dataset-productfinder').html(response.data);

        let field = $('#searchparam-header-autocomplete').val();
        if(field.length > 0) {
            $('.searchbox__results').addClass('active');
        } else {
            $('.searchbox__results').removeClass('active');
        }
    })
    .catch(function(error) {
        console.log(error);
    });

}

$(document).on('click', '.toggle-results-filter a', function(e) {
    e.preventDefault();

    $(this).toggleClass('active');
    $('.results-filter').toggleClass('closed');
});

$(document).on('change', '#results-filter-form select', function() {
    $(this).closest('form').submit();

    // let field = $(this).attr('name');
    // let content = $(this).parent().parent().data('id');
    // let country = $('#results-filter-form select[name="country"]').val();
    // let packsize = $('#results-filter-form select[name="pack-size"]').val();
    // let packaging = $('#results-filter-form select[name="packaging"]').val();
    // let tastingnotes = $('#results-filter-form select[name="tasting-notes"]').val();
    //
    // formData = new FormData(document.getElementById("results-filter-form"));
    // formData.append('field', field);
    // formData.append('content', content);
    //
    // $.ajax({
    //     url: "/products/getFilters?field=" + field + "&content=" + content + "&country=" + country + "&pack-size=" + packsize + "&packaging=" + packaging + "&tasting-notes=" + tastingnotes,
    //     type: "GET",
    //     data: content,
    //     contentType: false,
    //     processData: false,
    //     cache: false,
    //     beforeSend: function beforeSend() {
    //         $('#results-filter-form select').each(function () {
    //             $(this).prop('disabled', 'disabled');
    //         });
    //     },
    //     success: function success(data) {
    //         $('#results-filter-form').html(data);
    //     }
    // });
});

$(document).on('change', '#beer-finder-form select', function() {
    let field = $(this).attr('name');
    let content = $(this).parent().parent().data('id');
    let country = $('#beer-finder-form select[name="country"]').val();
    let packaging = $('#beer-finder-form select[name="packaging"]').val();
    let styles = $('#beer-finder-form select[name="styles"]').val();
    let properties = $('#beer-finder-form select[name="properties"]').val();

    formData = new FormData(document.getElementById("beer-finder-form"));
    formData.append('field', field);
    formData.append('content', content);

    $.ajax({
        url: "/products/beer-finder/getFilters?field=" + field + "&content=" + content + "&country=" + country + "&packaging=" + packaging + "&styles=" + styles + "&properties=" + properties,
        type: "GET",
        data: content,
        contentType: false,
        processData: false,
        cache: false,
        beforeSend: function beforeSend() {
            $('#beer-finder-form select').each(function () {
                $(this).prop('disabled', 'disabled');
                $('.finder__form .form-submit').prop('disabled', 'disabled');
            });
        },
        success: function success(data) {
            $('#beer-finder-form').html(data);
        }
    });
});

$(document).on('change', '#wine-finder-form select', function() {
    let field = $(this).attr('name');
    let content = $(this).parent().parent().data('id');
    let country = $('#wine-finder-form select[name="country"]').val();
    let type = $('#wine-finder-form select[name="type"]').val();
    let grape = $('#wine-finder-form select[name="grape"]').val();
    let tastingNotes = $('#wine-finder-form select[name="tasting-notes"]').val();
    let properties = $('#wine-finder-form select[name="properties"]').val();

    formData = new FormData(document.getElementById("wine-finder-form"));
    formData.append('field', field);
    formData.append('content', content);

    $.ajax({
        url: "/products/wine-finder/getFilters?field=" + field + "&content=" + content + "&country=" + country + "&type=" + type + "&grape=" + grape + "&tasting-notes=" + tastingNotes + "&properties=" + properties,
        type: "GET",
        data: content,
        contentType: false,
        processData: false,
        cache: false,
        beforeSend: function beforeSend() {
            $('#wine-finder-form select').each(function () {
                $(this).prop('disabled', 'disabled');
                $('.finder__form .form-submit').prop('disabled', 'disabled');
            });
        },
        success: function success(data) {
            $('#wine-finder-form').html(data);
        }
    });
});

$(document).on('change', '#gin-finder-form select', function() {
    let field = $(this).attr('name');
    let content = $(this).parent().parent().data('id');
    let tastingNotes = $('#gin-finder-form select[name="tasting-notes"]').val();
    let properties = $('#gin-finder-form select[name="properties"]').val();

    formData = new FormData(document.getElementById("gin-finder-form"));
    formData.append('field', field);
    formData.append('content', content);

    $.ajax({
        url: "/products/gin-finder/getFilters?field=" + field + "&content=" + content + "&tasting-notes=" + tastingNotes + "&properties=" + properties,
        type: "GET",
        data: content,
        contentType: false,
        processData: false,
        cache: false,
        beforeSend: function beforeSend() {
            $('#gin-finder-form select').each(function () {
                $(this).prop('disabled', 'disabled');
                $('.finder__form .form-submit').prop('disabled', 'disabled');
            });
        },
        success: function success(data) {
            $('#gin-finder-form').html(data);
        }
    });
});

$(document).on('click', '.reset-select', function() {
    $(this).siblings('select').val('All');
    $(this).closest('form').submit();
});

$(document).on('change', '.input-toggle', function() {
    let input = $(this).val();
    let toggle = $(this).data('toggle');
    let value = $(this).data('toggle-value');

    if(input == value) {
        $(toggle).show();
    } else {
        $(toggle).hide();
    }
});

// $(document).on('change', '#sort select', function() {
//     $(this).parent().trigger('submit');
// });
